<template>
    <div>
        <div class="new-product">
            <div class="my-4">
                <div v-if="step === currentStep">
                    <form @submit.prevent novalidate @input="markExtrasUpdated()">
                        <div class="px-4">
                            <div class="panel shaded">
                                <h5 class="border-bottom-lightest">Extra services</h5>

                                <div v-if="isLoadingExtras" class="text-center pb-4">
                                    <loader></loader>
                                </div>

                                <div class="text-center dark pb-4" v-else-if="extras.length == 0">
                                    <span>✨ Looks like you have no extras created, please create them <span class="bold underlined pointer" @click="createExtraClick">here</span>.</span>
                                </div>

                                <div v-else>
                                    <table v-if="extras" class="table narrow">
                                        <thead>
                                            <tr>
                                                <th class="text-center ">Name</th>
                                                <th class="text-center ">Price</th>
                                                <th class="text-center ">Quantity</th>
                                                <th class="text-center ">Unlimited</th>
                                                <th class="text-center ">Available on Agents</th>
                                                <th class="text-center ">Available on Widget</th>
                                                <th class="text-center ">Mandatory</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(extra, index) in form.extras" :key="extra.id">
                                                <td class="p-3">
                                                    <v-select
                                                        v-model="extra.item"
                                                        :options="extras"
                                                        label="name"
                                                        @input="selectedExtraChanged($event, extra)"
                                                        placeholder="- Select extra -">
                                                    </v-select>
                                                </td>
                                                <td class="p-3">
                                                    <v-select
                                                        v-model="extra.selectedPrice"
                                                        :options="extra.item.prices"
                                                        label="name"
                                                        @input="selectedPVPChanged($event, index)"
                                                        placeholder="- Select price -">
                                                    </v-select>
                                                </td>
                                                <td class="text-center">
                                                    <input type="number" style="width: 3rem;" v-model.number="extra.quantity" v-if="!extra.capacityUnlimited"/>
                                                    <span v-else class="dark">Unlimited</span>
                                                </td>
                                                <td class="text-center">
                                                    <checkbox v-model="extra.capacityUnlimited" @input="capacityUnlimitedChanged(extra)"></checkbox>
                                                </td>
                                                <td class="text-center">
                                                    <checkbox v-model="extra.isAvailableOnAgents" />
                                                </td>
                                                <td class="text-center">
                                                    <checkbox v-model="extra.isAvailableOnWidget" />
                                                </td>
                                                <td class="text-center">
                                                    <checkbox v-model="extra.isMandatory"></checkbox>
                                                </td>
                                                <td>
                                                    <i class="ico-delete largest medium" @click="deleteRow(index)"></i>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>

                                    <div class="add d-flex align-items-center pointer fs-small bold mt-5" @click="addRow">
                                        <i class="ico-add fs-smallest add-circle color-1"></i> Add new
                                    </div>

                                </div>

                            </div>
                        </div>

                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import extendedVSelect from '@/extends/vue-select'
    import Loader from '@/tools/loaders/loader1'

    export default {
        inject: {
            getProductBackup: { default: () => () => null }
        },
        props: {
            currentStep: Number,
        },
        data: function() {
            return {
                step: 3,
                form: {
                    extras: [],
                },
                isLoadingExtras: false,
                originalExtras: []
            }
        },
        watch: {
            stepNavigation(val) {
                this.$emit('stepNavigationChanged', val);
            }
        },
        mounted() {
            this.$emit('stepNavigationChanged', this.stepNavigation);
        },
        created: function() {
            this.form = structuredClone(this.getClonedItem);

            this.addPVPtoName(this.form.extras)
            if(this.form.extras){
                this.originalExtras = structuredClone(this.form.extras)
            }
        },
        computed: {
            ...mapGetters([
                'getClonedItem',
                'account',
                'getExtras',
                'getSelectedItem'
            ]),
            stepNavigation() {
                return { canProceed: true, canSave: true, canGoBack: true, isDirty: this.hasExtrasChanges };
            },
            hasExtrasChanges() {
                const backup = this.getProductBackup ? this.getProductBackup() : null;
                const original = backup && backup.extras ? backup.extras : [];
                return this.serializeExtras(this.form.extras) !== this.serializeExtras(original);
            },
            extras: function () {
                if(this.getExtras.length > 0){
                    var output = structuredClone(this.getExtras)
                } else {
                    var output = []
                }

                if(output.length > 0){

                    output.map(extra => {

                        //if it has prices (it should by now) tweaks the name wiht the price
                        if(extra.prices && extra.prices.length > 0){
                            extra.prices.map(price => {
                                price.name = price.name + ' - ' + price.grossprice + '€'
                                price.helperTweakedName = true
                            })
                        }
                    })

                    return output
                } else  {
                    return []
                }
            }
        },
        methods: {
            ...mapActions([
                'openModal',
                'clearSelectedExtra'
            ]),
            createExtraClick: function () {
                this.clearSelectedExtra()
                this.openModal('ExtraAdd')
            },
            addRow: function() {
                if (this.form.extras === undefined) {
                    this.$set(this.form, 'extras', []);
                }

                this.form.extras.push(this.createEmptyRow());
                this.markExtrasUpdated();
            },
            createEmptyRow: function() {
                let extraToDuplicate = structuredClone(this.extras[0])
                return {
                    id: 0,
                    item: extraToDuplicate,
                    isAvailableOnWidget: false,
                    isAvailableOnAgents: false,
                    isMandatory: false,
                    capacityUnlimited: true,
                    selectedPrice: extraToDuplicate.prices[0]
                };
            },
            selectedExtraChanged: function(event, extra) {
                //this has a fix to prevent setting prince[0] as selected on the first run
                // because this func will run at start [which sucks]
                let selectedPriceId = extra.selectedPrice.id
                let replaceSelectedPrice = true
                extra.item.prices.map(price => {
                    if(selectedPriceId == price.id){
                        replaceSelectedPrice = false
                    }
                })

                if(replaceSelectedPrice){
                    extra.selectedPrice = extra.item.prices[0]
                    this.markExtrasUpdated()
                }


            },
            selectedPVPChanged: function (a, index) {
                // code above ensures that it is only triggered if changed by user and not on page load
                if(!this.originalExtras[index]){
                    this.markExtrasUpdated()
                    return false
                }
                if(this.form.extras[index] && this.originalExtras[index].selectedPrice.id != a.id){
                    this.markExtrasUpdated()
                    return false
                }
            },
            capacityUnlimitedChanged: function(extra) {
                if(extra.capacityUnlimited){
                    extra.quantity = null
                } else {
                    extra.quantity = 0
                }
            },
            addPVPtoName: function(extras) {
                if(extras && extras.length > 0){
                    for (let extra of extras) {
                        if(!extra.selectedPrice.helperTweakedName){
                            extra.selectedPrice.name = extra.selectedPrice.name + ' - ' + extra.selectedPrice.grossprice + '€'
                            extra.selectedPrice.helperTweakedName = true
                        }
                    }
                }
            },
            serializeExtras: function(extras) {
                return JSON.stringify((extras || []).map(e => ({
                    id: e.id,
                    itemId: e.item ? e.item.id : null,
                    selectedPriceId: e.selectedPrice ? e.selectedPrice.id : null,
                    quantity: e.quantity != null ? e.quantity : null,
                    capacityUnlimited: !!e.capacityUnlimited,
                    isMandatory: !!e.isMandatory,
                    isAvailableOnAgents: !!e.isAvailableOnAgents,
                    isAvailableOnWidget: !!e.isAvailableOnWidget,
                })));
            },
            markExtrasUpdated: function() {
                if (!this.form.updateFlags) {
                    this.$set(this.form, 'updateFlags', {});
                }
                this.form.updateFlags.extras = true;
            },
            getStepState: function() {
                return { invalid: false, form: this.form };
            },
            readyToSave: function() {
                this.$emit('readyToSave', { invalid: false, form: this.form });
            },
            deleteRow: function(row) {
                this.markExtrasUpdated()
                this.form.extras.splice(row, 1);
            },
        },
        components: {
            vSelect: extendedVSelect,
            Loader
        },
    }
</script>



// WEBPACK FOOTER //
// ProductExtras.vue?c150e96c